// extracted by mini-css-extract-plugin
export default {"recordList":"recordList--ljseX","emptyDesc":"emptyDesc--XutEH"};